import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Avatar from '../Components/Avatar';

const SuggestionItem = ({ name, email, login, active, onClick }) =>
    (<div
        className={`suggestion ${active ? 'selected' : ''}`}
        onClick={onClick}
    >
        <Avatar
            name={name}
            email={email}
            login={login}
        />
        <span className='user-info'>
            <span className='caption'>
                { name }
            </span>
            <span className='label'>
                { email }
                { login ? ` (${login})` : '' }
            </span>
        </span>
    </div>);

SuggestionItem.propTypes = {
    name: PropTypes.string,
    email: PropTypes.string,
    login: PropTypes.string,
    active: PropTypes.bool,
    onClick: PropTypes.func
};

export default observer(SuggestionItem);
